import { IState } from '../../../store';

export function getOfferUserId(state: IState): number | null {
  return state.offerData?.offer?.userId || null;
}
